import template from './eurail-cards.html';
import railcardsCardnumberModal from '../../../ukrail/eurail-railcards-modal/eurail-railcards-cardnumber-modal.html';
import {SIZE_LARGE} from '../../modal/modal-service';

const DIRECTIVE_NAME = EurailCards.DIRECTIVE_NAME = 'ktEurailCards';
export default function EurailCards() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: EurailCardsController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            railCards: `=${DIRECTIVE_NAME}RailCards`,
            travellersCount: `=${DIRECTIVE_NAME}TravellersCount`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function EurailCardsController(
    $scope,
    modalService,
    eurailCardsService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        editCard,
    });

    function $onInit() {
        watchTravellerCountChange();
        initCards();
    }

    function editCard(card, passenger) {
        $scope.cardType = card.type;
        $scope.cardNumber = card.number;
        $scope.isEdit = true;
        $scope.saveCard = eurailCardsService.saveCard;
        $scope.numberChange = eurailCardsService.numberChange;
        $scope.deleteCard = eurailCardsService.deleteCard;
        $scope.passenger = passenger;
        modalService.openModal({
            template: railcardsCardnumberModal,
            scope: $scope,
            size: SIZE_LARGE,
        });
    }

    function watchTravellerCountChange() {
        $scope.$watch(() => vm.travellersCount, () => {
            onTravellerCountChange();
        });
    }

    function initCards() {
        const passengers = [];
        for (let i = 1; i <= vm.travellersCount; i++) {
            passengers.push({cards: []});
        }

        vm.model.passengersRailcards = passengers;
    }

    function onTravellerCountChange() {
        const passengers = vm.model.passengersRailcards;
        if (!passengers) {
            return;
        }

        const difference = vm.travellersCount - passengers.length;
        if (difference > 0) {
            for (let i = 1; i <= difference; i++) {
                passengers.push({cards: []});
            }
        } else if (difference < 0) {
            for (let i = 1; i <= -difference; i++) {
                passengers.pop();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/eurail-cards/eurail-cards-component.js